import { InjectionToken } from "@angular/core";

/**
 * Voice API backend links goes
 * @see https://confluence.nfon.net/display/VB/APIs
 */
export const VOICE_API_PATHS: InjectionToken<string[]> = new InjectionToken<
  string[]
>("Voice API Paths", {
  factory: () => ["voice-control-api"],
});
